<template>
    <div id="basic-card" class="home-page">
        <div class="vx-row">
            <div class="loader-block loader-block2" v-if="axiosInstance">
                <div class="loading">
                    <div class="effect-1 effects"></div>
                    <div class="effect-2 effects"></div>
                    <div class="effect-3 effects"></div>
                </div>
            </div>
            <h2 class="vx-col w-full" style="text-align: center; margin: 0 0 20px 0">{{ 'Review list' }}</h2>

            <vx-card>
                <div class="d-flex justify-between">
                    <div class="d-flex">
                        <vs-input class=" vs-input-shadow-drop vs-input-no-border d-theme-input-dark-bg"
                                  placeholder="Search here"
                                  v-on:keyup="getSearchData"
                                  style="margin-right: 10px;width: 300px"
                                  v-model="searchQuery"/>
                    </div>
                    <div class="d-flex">
                        <div style="width: 350px">
                            <v-select name="type"
                                      v-validate="'required'" :options="types"
                                      v-model="type"
                                      @input="getSearchData"
                                      :clearable="false"
                                      label="name"
                                      :reduce="item => item.value"/>
                            <span class="text-danger text-sm validation-error"
                                  v-show="errors.has('type')">{{ errors.first('type') }}</span>

                        </div>
                    </div>
                </div>
                <div id="data-container" style="min-height: 30px; margin-top: 20px" class="relative">
                    <table v-if="items && items.length > 0"
                           class="data-table mt-3">
                        <thead>
                        <th style="width: 25%">Title</th>
                        <th style="width: 8%">Type</th>
                        <th style="width: 20%">Tags</th>
                        <th style="width: 15%">Subject</th>
                        <th style="width: 15%">Thumbnail</th>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in items" :key="index">
                            <td>
                                <div>
                                    <router-link :to="$store.state.user.role.name === 'Authenticated' ? ('/' + item._id) : ('/' + item._id + '/edit')">
                                        {{item.title}}
                                    </router-link>
                                </div>
                            </td>
                            <td>
                                <div>
                                    {{item.asset_type}}
                                </div>
                            </td>
                            <td>
                                <div>
                                    <div v-for="(el, index) in item.keywords"
                                         :key="index"
                                         class="con-vs-chip vs-chip-dark con-color"
                                         style="color: rgba(255, 255, 255, 0.9);">
                                        <span class="text-chip vs-chip--text">{{ el }}</span>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div>
                                    <div v-for="(el, index) in item.subject"
                                         :key="index"
                                         class="con-vs-chip vs-chip-dark con-color"
                                         style="color: rgba(255, 255, 255, 0.9);">
                                        <span class="text-chip vs-chip--text">{{ el }}</span>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="asset-thumbnail-block">
                                    <div class="asset-thumbnail-section">
                                        <HoverThumb :main="item.thumbnail" :list="item.thumbnails" :asset="item"/>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="pagination-block">
                    <vs-pagination :total="totalPages" :max="7" v-model="currentPage" class="mt-base" v-if="totalPages > 1"
                                   @change="handlePaginationChange"></vs-pagination>
                </div>
            </vx-card>

        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import vSelect from 'vue-select'
    import HoverThumb from "../components/HoverThumb";
    export default {
        name: 'ReviewList',
        components: {
            HoverThumb,
            vSelect
        },
        head() {
            return {
                title: {
                    inner: 'AMP',
                    separator: ' ',
                    complement: ''
                },
                meta: [
                    {hid: 'description', name: 'description', content: ''}
                ]
            }
        },
        data() {
            return {
                orderBy: {
                    'order': 'desc',
                    'order_by': 'updatedAt'
                },
                searchQuery: '',
                isDeletePage: false,
                isLoading: false,
                axiosInstance: false,
                axiosInstance2: false,
                debounce: false,
                items: [],
                mediaItems: [],
                currentPage: 1,
                totalItems: 0,
                itemsPerPage: 24,
                totalPages: 0,
                isMounted: false,
                isMounted2: false,
                selected: {},
                type: 'public',
                types: [{
                    name: 'All public assets',
                    value: 'public'
                }, {
                    name: 'All published assets in past 24 hours',
                    value: 'published'
                }, {
                    name: 'All Academic & Artist reviewed assets',
                    value: 'acaarr'
                }, {
                    name: 'All Academic reviewed assets',
                    value: 'acr'
                }, {
                    name: 'All Artist reviewed assets',
                    value: 'arr'
                }, ],
                asset_type: '3D',
                replace_asset_type: '3D',
            }
        },
        computed: {},
        mounted() {
            if (this.$route.name === 'deleted-assets') {
                this.isDeletePage = true;
            }
            if (this.$route.query.type) {
                this.type = this.$route.query.type;
            }
            if (this.$route.query.page) {
                this.currentPage = +this.$route.query.page;
            }
            if (this.$route.query.per_page) {
                this.itemsPerPage = +this.$route.query.per_page;
            }

            if (this.$route.query.order && this.$route.query.order_by) {
                this.orderBy = {
                    order_by: this.$route.query.order_by,
                    order: this.$route.query.order
                };
            }
            this.search();
        },
        methods: {
            updateUrl() {
                let path = this.$route.path;
                let qObj = {
                    per_page: this.itemsPerPage
                };
                if (this.orderBy && this.orderBy.order && this.orderBy.order_by) {
                    qObj.order_by = this.orderBy.order_by;
                    qObj.order = this.orderBy.order;
                }
                if (this.currentPage !== 1) {
                    qObj.page = this.currentPage;
                }
                if (this.type) {
                    qObj.type = this.type;
                }
                if (this.$store.state.searchQuery) {
                    qObj.search = this.$store.state.searchQuery;
                }
                let qArr = Object.keys(qObj).reduce((acc, k) => acc.concat(Array.isArray(qObj[k]) ? qObj[k].map(v => [k, v]) : [[k,qObj[k]]]), []);
                let q = "?" + new URLSearchParams(qArr).toString()
                history.pushState(
                    {},
                    null,
                    path+q
                )
            },
            handlePaginationChange() {
                if (this.isMounted) {
                    this.items = [];
                    this.search();
                }
            },
            getSearchData() {
                clearTimeout(this.debounce);
                this.debounce = setTimeout(() => {
                    this.currentPage = 1;
                    this.search()
                }, 500)

            },
            search() {
                this.updateUrl();
                const CancelToken = axios.CancelToken;
                const source = CancelToken.source();
                const source2 = CancelToken.source();

                let url = `/assets`;

                let qObj = {
                    _limit: this.itemsPerPage,
                    _start: (this.currentPage - 1) * this.itemsPerPage
                };

                if (this.orderBy) {
                    qObj._sort = `${this.orderBy.order_by}:${this.orderBy.order}`
                }
                if (this.searchQuery) {
                    qObj._q = this.searchQuery;
                }
                if (this.type) {
                    if (this.type === 'public') {
                        qObj.visibility = 'public'
                    }
                    if (this.type === 'published') {
                        let d = new Date();
                        d.setDate(d.getDate() - 1);
                        qObj.published = true;
                        qObj.published_at_gte = d.getTime();
                    }
                    if (this.type === 'acaarr') {
                        qObj.academic_reviewed = true;
                        qObj.artist_reviewed = true;
                    }
                    if (this.type === 'acr') {
                        qObj.academic_reviewed = true;
                    }
                    if (this.type === 'arr') {
                        qObj.artist_reviewed = true;
                    }
                }
                let qArr = Object.keys(qObj).reduce((acc, k) => acc.concat(Array.isArray(qObj[k]) ? qObj[k].map(v => [k, v]) : [[k,qObj[k]]]), []);
                let q = "?" + new URLSearchParams(qArr).toString()
                url += q;
                if (this.axiosInstance) {
                    this.axiosInstance.cancel();
                }
                this.showImages = false;
                this.axiosInstance = source;

                this.$axios.get(url, {cancelToken: source.token}).then(res => {
                    this.items = res.data;
                    this.axiosInstance = false;
                    setTimeout(() => {
                        this.showImages = true;
                    }, 100)
                    this.isMounted2 = false;

                    if (!this.isMounted) {
                        setTimeout(() => {
                            this.isMounted = true;
                        }, 200)
                    }
                }).catch(e => {
                    this.axiosInstance = false;
                    setTimeout(() => {
                        this.showImages = true;
                    }, 100)
                    console.log('catch_search', e)
                });

                let url2 = `/assets/count`
                delete qObj._sort;
                delete qObj._limit;
                delete qObj._start;
                qArr = Object.keys(qObj).reduce((acc, k) => acc.concat(Array.isArray(qObj[k]) ? qObj[k].map(v => [k, v]) : [[k,qObj[k]]]), []);
                q = "?" + new URLSearchParams(qArr).toString()
                url2 += q;
                if (this.axiosInstance2) {
                    this.axiosInstance2.cancel();
                }
                this.axiosInstance2 = source2;
                this.$axios.get(url2, {cancelToken: source2.token}).then(res => {
                    this.totalItems = res.data;
                    this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage)
                    this.axiosInstance2 = false;
                }).catch(e => {
                    console.log('catch_search', e)
                })
            },
            changePerPage(limit) {
                this.itemsPerPage = limit;
                setTimeout(() => {
                    this.search()
                }, 10)
            }
        },
        watch: {

        },
    }
</script>
